export enum EventResizeHandleAlignment {
  Left,
  Right,
}
